import type { TFunction } from 'i18next';
import { type AnyObjectSchema, object } from 'yup';

type CreateAtLeastOneItemInMapSchemaParameters = {
  label: string;
  schema?: AnyObjectSchema;
  t: TFunction;
};

export const createAtLeastOneItemInMapSchema = ({
  label,
  schema = object(),
  t,
}: CreateAtLeastOneItemInMapSchemaParameters) => {
  return schema.test({
    exclusive: true,
    message: t('Provide at least one {label}', { label }),
    name: 'hasAtLeastOneItemSelected',
    test: value => (value ? Object.values(value).length > 0 : false),
  });
};
